module.exports = __webpack_public_path__ + "img/linfen.fe511e29.jpg";